import React from 'react';

import { Box, Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ChipProposalStatus, CollapsedBreadcrumbs } from 'common/components';

import ReportStatusIcon from '../../reportList/components/ReportStatusIcon';
import { REPORT_STATUS_CONFIG } from '../../reportList/constants';

import TitlePreview from './TitlePreview';

const HeaderPreview = ({
    breadcrumbLocations,
    currentBreadcrumb,
    reportStatus,
}) => {
    const { t } = useTranslation();

    const statusConfig = REPORT_STATUS_CONFIG[reportStatus];

    return (
        <Box>
            <Grid
                container
                spacing={0}
                sx={{ alignItems: 'center', p: '16px 16px 8px 16px' }}
            >
                <Grid size={{ lg: 15, md: 14, xs: 13 }}>
                    <TitlePreview name={t('Report')} />
                </Grid>

                {statusConfig && (
                    <Grid size={{ lg: 3, md: 4, xs: 5 }} textAlign="right">
                        <ChipProposalStatus
                            icon={<ReportStatusIcon status={reportStatus} />}
                            label={t(statusConfig.label)}
                        />
                    </Grid>
                )}

                <Grid size={{ xs: 18 }} sx={{ pl: { md: '40px' } }}>
                    <CollapsedBreadcrumbs
                        current={currentBreadcrumb}
                        locations={breadcrumbLocations}
                    />
                </Grid>
            </Grid>

            <Divider sx={{ mb: 0 }} />
        </Box>
    );
};

HeaderPreview.propTypes = {
    breadcrumbLocations: PropTypes.array,
    currentBreadcrumb: PropTypes.string,
    reportStatus: PropTypes.number,
};

export default HeaderPreview;
